import DataTable from './dataTable'

/******************************************************************************
 *  Sales Deal
 *****************************************************************************/

/**
 * @type {SalesDeal}
 */
export default class SalesDeal extends DataTable {

    /**
     * @param {String} resource
     */
    constructor () {
        super('/queue/deal', '/deals')
        this.columns = [
            this.prototypes.column('customer_name', 'customers.name', true, true),
            this.prototypes.column('user_name', 'user_name', false, true),
            this.prototypes.column('stage', 'stg.id', false, true),
            this.prototypes.column('customer_origin', '', false, true),
            this.prototypes.column('product_id', 'p.id', false, true),
            this.prototypes.column('product_name', 'p.name', false, true),
            this.prototypes.column('cost', 'deal.cost', false, true),
            this.prototypes.column('customer_phone', 'customers.phone', true, false),
            this.prototypes.column('customer_mobile', 'customers.mobile', true, false),
            this.prototypes.column('customer_email', 'customers.email', true, false),
            this.prototypes.column('updated_at', 'deal.updated_at', false, true),
            this.prototypes.column('saled_at', 'deal.saled_at', false, true),
            this.prototypes.column('created_at', 'deal.created_at', false, true),
            this.prototypes.column('stage', 'deal.funnel_stage', false, false),
            this.prototypes.column('id', 'deal.id', true, false),
            this.prototypes.column('team_id', 't.id', false, false),
            this.prototypes.column('manager_id', 'mfo.id', false, false),
            this.prototypes.column('broker_id', 'bfo.id', false, false),
            this.prototypes.column('customer_cpf', 'customers.cpf', true, false),
            this.prototypes.column('funnel_stage_status_id', 'deal.funnel_stage_status_id', false, false),
            this.prototypes.column('tags', 'tags.tag', false, true),
            this.prototypes.column('owner', 'filter_owner', false, true),
            this.prototypes.column('idle_color', 'idle.updated_at', false, true),
            this.prototypes.column('tasks', 'task.updated_at', false, true),
            this.prototypes.column('customer_id', 'deal.customer_id', false, false),
        ]
    }
}